/**
 * Created by Administrador on 10/04/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('manageBoardingGateCtrl', manageBoardingGateCtrl);

    manageBoardingGateCtrl.$inject = ['$timeout', '$stateParams', 'linkService',
        'flights', 'dateService', 'datePickerService','flightService'];

    function manageBoardingGateCtrl($timeout, $stateParams, linkService,flights, dateService, datePickerService, flightService){

        var vm = this;
        vm.editIndexX = -1;
        vm.auxFlight = {};
        vm.linkService = linkService;
        vm.flights = getFlights(linkService, flights);
        vm.flightFilter = {
            'date': ($stateParams.date != "") ? new Date(parseInt($stateParams.date)) : new Date()
        }

        vm.dateParam = $stateParams.date;

        //vm.modelAircraftFlights = [];
        //vm.radioFlight = 'grid';
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.beforeYesterday = new Date();
        vm.beforeYesterday = dateService.addDays(vm.beforeYesterday, -3);
        vm.beforeYesterday.setHours(0,0,0);

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    vm.changeDay();
                }
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.changeDay = function(){
            $timeout(function(){
                var date = vm.flightFilter.date;
                if(date != undefined){
                    var dateTime = date.getTime();
                    linkService.reloadRoute(linkService.getCurrentRouteName(), {date: dateTime})
                }
            }, 100);
        }

        vm.editBoardingGate = function(indexX){
            if(vm.editIndexX == indexX || vm.editIndexX == -1){
                vm.flights[indexX].disabledClass = false;
                vm.flights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxFlight = angular.copy(vm.flights[indexX]);
            }
        }

        vm.cancelBoardingGate = function(indexX){
            vm.flights[indexX] = angular.copy(vm.auxFlight);
            vm.flights[indexX].disabledClass = true;
            vm.flights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.auxFlight = {};
        }

        vm.saveBoardingGates = function(valid,indexX){
            if(valid){
                var updateForm = {
                    'departureFlights': vm.flights[indexX].departureFlights
                }

                flightService.updateBoardingGates(vm.flights[indexX].flightId, updateForm)
                    .then(function(response){
                        linkService.reloadRoute('manageBoardingGate', null);
                    });
            }
        }

        function getFlights(linkService,flights){
            var rFlights = [];
            for(var i=0; i<flights.length; i++){
                rFlights.push(
                    {
                        "flightNumber": flights[i].flightNumber,
                        "flightId": linkService.getLinkId(flights[i]._links.self.href),
                        "disabledClass": true,
                        "disabledEdit": false,
                        "showEdit": true,
                        "showSave": false,
                        "departureFlights":[]
                    }
                );
                for(var j=0; j<flights[i]._embedded.departureflights.length; j++){
                    rFlights[i].departureFlights.push(
                        {
                            "departureDate": flights[i]._embedded.departureflights[j].departureDate,
                            "arrivalDate": flights[i]._embedded.departureflights[j].arrivalDate,
                            "departureFlightId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._links.self.href),
                            "modelAircraftName": flights[i]._embedded.departureflights[j]._embedded.modelAircraft.name,
                            "segmentName": flights[i]._embedded.departureflights[j]._embedded.segment.name,
                            "boardingGates": [], //flights[i]._embedded.departureflights[j]._embedded.airport._embedded.boardinggates,
                            "boardingGateId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.boardinggate._links.self.href),
                            "aircraftPlaque":(flights[i]._embedded.departureflights[j]._embedded.aircraft?flights[i]._embedded.departureflights[j]._embedded.aircraft.plaque:undefined)
                        }
                    )
                    for(var k=0; k<flights[i]._embedded.departureflights[j]._embedded.airport._embedded.boardinggates.length; k++){
                        rFlights[i].departureFlights[j].boardingGates.push(
                            {
                                "number": flights[i]._embedded.departureflights[j]._embedded.airport._embedded.boardinggates[k].number,
                                "boardingGateId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.airport._embedded.boardinggates[k]._links.self.href)
                            }
                        )
                    }
                }
            }
            return rFlights;
        }
    }
})();
